export default __webpack_public_path__ + "static/media/pic14.cd93ee8f.jpg";